import image from '../../../../assets/kitman.jpg';

const ProjectManager = {
  image,
  name: 'Kitman',
  position: 'CEO',
  bulletPoint1: 'Managing Project deadline to ensure issues can be finish on time',
  bulletPoint2: 'Resolving commutation issue between dev, designer and product manager',
  bulletPoint3: 'Improving CI/CD pipeline for dev teams, introducing new tech stack to dev team',
  LinkedinURL: 'https://www.linkedin.com/in/kitman-yiu/'
};
export default ProjectManager;
